import { render, staticRenderFns } from "./ZipCodeItem.vue?vue&type=template&id=dec0b2d4&"
import script from "./ZipCodeItem.vue?vue&type=script&lang=js&"
export * from "./ZipCodeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports